import React from 'react';
import { useTranslation } from 'react-i18next';
import { PolicyConsentsLayoutContainerProps } from './containers/PolicyConsentsLayoutContainer';

import cssForms from '../../assets/scss/Forms.scss';
import PMPolicies from './PMPolicies';
import css from './PolicyConsentsLayout.scss';

const PolicyConsentsLayout: React.FC<PolicyConsentsLayoutContainerProps> = (containerProps) => {
    const { t } = useTranslation();
    return (
        <React.Fragment>
            <div className={css.submitConsents}>
                <div className={cssForms.container}>
                    <h2 className={css.marginBottom40}>{t('policyConsents.header')}</h2>
                    <PMPolicies />
                </div>
            </div>
        </React.Fragment>
    );
};
export default PolicyConsentsLayout;
